import React from 'react'
import { ErrorBoundary as ReactErrorBoundary, FallbackProps } from 'react-error-boundary'

/**
 * Error fallback component that displays when an error occurs
 */
const ErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => (
  <div className="flex flex-col items-center justify-center min-h-screen p-4">
    <div className="p-6 bg-white rounded shadow-lg max-w-lg">
      <h2 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h2>
      <p className="text-gray-700 mb-4">{error.message}</p>
      <button
        type="button"
        onClick={resetErrorBoundary}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
        Try again
      </button>
    </div>
  </div>
)

interface ErrorBoundaryProps {
  children: React.ReactNode
}

/**
 * Error boundary component to catch errors in the component tree
 */
export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => <ReactErrorBoundary FallbackComponent={ErrorFallback}>{children}</ReactErrorBoundary>
